var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "plan-group"
  }, [_vm._l(_vm.showList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "plan",
      style: _vm.showList.length === index + 1 ? "margin-right:50px" : ""
    }, [_c("div", {
      staticClass: "part"
    }, [_c("span", {
      staticClass: "delete-icon",
      on: {
        click: function ($event) {
          return _vm.deletePlan(item.id, index);
        }
      }
    }, [_vm._v("×")]), _c("a-icon", {
      staticClass: "edit-icon",
      staticStyle: {
        color: "#7f7f7f",
        "font-size": "12px"
      },
      attrs: {
        type: "form"
      },
      on: {
        click: function ($event) {
          return _vm.openEditPlan(item);
        }
      }
    }), _c("a-icon", {
      staticStyle: {
        width: "100%",
        "font-size": "34px"
      },
      attrs: {
        type: item.iconName
      }
    }), _c("a-tooltip", {
      attrs: {
        placement: "rightBottom"
      }
    }, [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])], 2)], 1), _vm.showList.length && _vm.showList.length !== index + 1 ? _c("svg-icon", {
      staticClass: "arrow",
      attrs: {
        icon: "longarrow",
        size: 36
      }
    }) : _vm._e()], 1);
  }), _c("div", {
    staticClass: "add-plan",
    on: {
      click: function ($event) {
        return _vm.openEditPlan(false);
      }
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "plus",
      size: 36
    }
  }), _c("span", {
    staticClass: "font"
  }, [_vm._v(_vm._s(_vm.$t("添加进度")))])], 1), _c("plan-modal", {
    attrs: {
      visible: _vm.addVisible,
      isEdit: _vm.isEdit
    },
    on: {
      save: _vm.savePlan,
      cancel: _vm.closeVisible
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };